import { useContext } from 'react';
import { Context } from './Provider';
function useLogger() {
  const context = useContext(Context);
  return context;
}

export default useLogger;
